// Contact Form Panther Labels
export const FormStrings = {
  NAME_PLACEHOLDER_LABEL: 'fullName_label',
  EMAIL_PLACEHOLDER_LABEL: 'email_label',
  FORM_SUBMIT_BUTTON_LABEL: 'formSubmit_label',
  INTAKE_FORM_PRIVACY_NOTICE_LABEL_SHORT: 'updated_intake_form_label',
  ORIGINAL_INTAKE_FORM_PRIVACY_NOTICE: 'original_intake_form_label',
  OTHER_LABEL: 'other_label',
  SUPPLIER_LABEL: 'supplier_label',
  SUPPLIER_DESCRIPTION: 'supplier_description',
  AWS_CUSTOMER_LABEL: 'awsCustomer_label',
  AWS_CUSTOMER_DESCRIPTION: 'awsCustomer_description',
  VENDOR_LABEL: 'vendor_label',
  VENDOR_DESCRIPTION: 'vendor_description',
  SELLING_PARTNER_LABEL: 'sellingPartner_label',
  SELLING_PARTNER_DESCRIPTION: 'sellingPartner_description',
  TCP_SIGNATORY_LABEL: 'tcpSignatory_label',
  TCP_SIGNATORY_DESCRIPTION: 'tcpSignatory_description',
  AMAZON_CUSTOMER_LABEL: 'amazonCustomer_label',
  AMAZON_CUSTOMER_DESCRIPTION: 'amazonCustomer_description',
  INPUT_TOO_LONG_LABEL: 'inputTooLong_label',
  JOB_TITLE_LABEL: 'jobTitle_label',
  COMPANY_LABEL: 'company_label',
  WEBSITE_LABEL: 'website_label',
  COMPANY_SIZE_LABEL: 'companySize_label',
  COUNTRY_LABEL: 'country_label',
  AMAZON_RELATION_LABEL: 'amazonRelation_label',
  INVALID_EMAIL_LABEL: 'invalidEmail_label',
  INVALID_INPUT_LABEL: 'invalidInput_label',
  ERRORS_PRESENT_DESCRIPTION: 'errorsPresent_description',
  PERSONAL_INFORMATION_HEADER: 'personalInformation_header',
  COMMITMENTS_INFORMATION_HEADER: 'commitmentsInformation_header',
  COMMITMENTS_INFORMATION_HEADER_TWO: 'commitmentsInformation_header2',
  REQUIRED_FIELDS_LABEL: 'requiredFields_label',
  YES_SELECTOR_OPTION: 'yesSelectorOption_label',
  NO_SELECTOR_OPTION: 'noSelectorOption_label',
  IN_PROCESS_SELECTOR_OPTION: 'inProcessSelectorOption_label',
  SELECT_OPTION: 'selectOption_label',
  IS_MANDATORY: 'isMandatory_label',
  ERROR_YEAR_DATE: 'errorYearDate_label',
  ERROR_MONTH_YEAR_DATE: 'errorMonthYearDate_label',
  QUESTION_1_ERROR: 'question1Error_label',
  SUBQUESTION_1_ERROR: 'subquestion1Error_label',
  QUESTION_2_ERROR: 'question2Error_label',
  QUESTION_3_ERROR: 'question3Error_label',
  SUBQUESTION_3_ERROR: 'subquestion3Error_label',
  QUESTION_4_ERROR: 'question4Error_label',
  INTAKE_FORM_TITLE: 'intakeFormTitle_label',
  INTAKE_FORM_COPY_ONE: 'intakeFormCopy1_label',
  INTAKE_FORM_COPY_TWO: 'intakeFormCopy2_label',
  INTAKE_FORM_COPY_THREE: 'intakeFormCopy3_label',
  INTAKE_FORM_COPY_FOUR: 'intakeFormCopy4_label',
  INTAKE_FORM_BACK_BUTTON: 'intakeForm_backButton_label',
  INTAKE_FORM_BACK_BUTTON_MY_ACCOUNT: 'intakeForm_backButton_myAccount_label',
  INTAKE_FORM_HIGHLIGHTED_CARD_TITLE: 'intakeForm_highlightedCard_title',
  INTAKE_FORM_HIGHLIGHTED_CARD_SUBTITLE: 'intakeForm_highlightedCard_subtitle',
  INTAKE_FORM_HIGHLIGHTED_CARD_ITEM_1: 'intakeForm_highlightedCard_item_1',
  INTAKE_FORM_HIGHLIGHTED_CARD_ITEM_2: 'intakeForm_highlightedCard_item_2',
  INTAKE_FORM_HIGHLIGHTED_CARD_ITEM_3: 'intakeForm_highlightedCard_item_3',
  NEXT_STEP: 'next_step',
  BACK: 'back',
  CONTINUE: 'continue',
  SAVE_FORM_ERROR_LABEL: 'saveFormError_label',
  FEEDBACK_SUBMITTED_CREDIT_LABEL: 'feedbackSubmitted_credit_label',
  THANKS_CREDIT_LABEL: 'thanks_credit_label',
  THANKS_TOAST_TITLE: 'thanks_toast_title',
  THANKS_TOAST_BODY: 'thanks_toast_body',
  THANKS_CREATE_YOUR_PROFILE_LABEL: 'thanks_create_your_profile_label',
  THANKS_SIGN_IN_LABEL: 'thanks_sign_in_label',
  THANKS_SIGN_IN_CREATE_ACCOUNT_CTA: 'thanks_sign_in_create_account_cta_label',
  THANKS_AUTHENTICATED_BODY: 'thanks_authenticated_body',
  THANKS_AUTHENTICATED_CTA: 'thanks_authenticated_cta_label',
  THANKS_OTHER_COUNTRY_TOAST_BODY: 'thanks_other_country_toast_body',
  PREVIOUS_PAGE_CREDIT_CTA: 'previousPage_credit_label',
  LINK_CREDIT_LABEL: 'link_credit_label',
};

export const BillingAddressInformationFormStrings = {
  SAVE_CHANGES_BUTTON_LABEL: 'saveChangesButton_label',
  ERRORS_PRESENT_DESCRIPTION: 'errorsPresent_description',
  FIELDS_REQUIRED_DESCRIPTION: 'fieldsRequired_description',
  IS_MANDATORY_LABEL: 'isMandatory_label',
  INPUT_TOO_LONG_LABEL: 'inputTooLong_label',
  COUNTRY_FIELD_LABEL: 'countryField_label',
  PHONE_NUMBER_FIELD_LABEL: 'phoneNumberField_label',
  ADDRESS_FIELD_LABEL: 'addressField_label',
  FLOOR_OR_SUITE_FIELD_LABEL: 'floorOrSuiteField_label',
  ZIPCODE_FIELD_LABEL: 'zipcodeField_label',
  CITY_FIELD_LABEL: 'cityField_label',
  STATE_FIELD_LABEL: 'stateField_label',
  ZIPCODE_INVALID_FORMAT_LABEL: 'zipcode_invalidFormat_label',
  ZIPCODE_OUT_OF_RANGE_LABEL: 'zipcode_outOfRange_label',
  STATE_INVALID_FORMAT_LABEL: 'state_invalidFormat_label',
  STATE_INVALID_CODE_LABEL: 'state_invalidCode_label',
  PHONE_NUMBER_INVALID_FORMAT_LABEL: 'phoneNumber_invalidFormat_label',
};

export const CommonFormStrings = {
  LOADER_ARIA_LABEL: 'loader_ariaLabel',
  BACK_BUTTON_LABEL: 'backButton_label',
  FORM_HEADING: 'form_heading',
  FORM_DESCRIPTION: 'form_description',
};

export const IntakeFormQuestionInfo: { [name: string]: { id: string; text: string } } = {
  NET_ZERO_CARBON_TARGET_CRITERIA_QUESTION: {
    id: 'NetZeroTargetsThreeScopesQuestion',
    text: 'intakeFormQuestion1_label',
  },
  SUBQUESTION_1: {
    id: 'NetZeroTargetYearQuestion',
    text: 'intakeFormSubquestion1_label',
  },
  MEASURE_AND_REPORT_CRITERIA_QUESTION: {
    id: 'MeasureReportGreenhouseGasEmissionsQuestion',
    text: 'intakeFormQuestion2_label',
  },
  DECARBONIZATION_COMMITMENT_CRITERIA_QUESTION: {
    id: 'ParisAgreementDecarbonizationStrategiesQuestion',
    text: 'intakeFormQuestion3_label',
  },
  SUBQUESTION_3: {
    id: 'TargetCompletionDateQuestion',
    text: 'intakeFormSubquestion3_label',
  },
};

export const TARGET_DATE_VALIDATION_ERROR_LABEL = 'intakeFormTargetDateValidationError_label';

export const MarketplaceRedirectStrings = {
  TITLE: 'marketplaceRedirect_title',
  BODY: 'marketplaceRedirect_body',
  CONFIRM_TEXT: 'marketplaceRedirect_confirmText',
  DROPDOWN_LABEL: 'marketplaceRedirect_dropdownLabel',
  CANCEL_BUTTON: 'marketplaceRedirect_cancelButton',
  CONFIRM_BUTTON: 'marketplaceRedirect_confirmButton',
};

export const BuyerCriteriaStrings = {
  DISCLAIMER_TITLE: 'disclaimer_title',
  DISCLAIMER_COPY: 'disclaimer_copy',
  NET_ZERO_TITLE: 'netZero_title',
  EMISSIONS_TITLE: 'emissions_title',
  DECARBONIZATION_TITLE: 'decarbonization_title',
  SUBQUESTION_FORMAT: 'subquestion_format',
};
